import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_GIFT_CARDS } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'checkout/gift-cards/:requestId',
    name: CHECKOUT_GIFT_CARDS.SELF,
    component: () => import('./layout/GiftCardFlow/GiftCardFlow.vue'),
    redirect: { name: CHECKOUT_GIFT_CARDS.BILLING_ADDRESS },
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
      auth: {
        required: true,
        redirection: { name: ROUTES.AUTH.LOGIN },
      },
    },
    children: [
      {
        path: 'billing-address',
        name: CHECKOUT_GIFT_CARDS.BILLING_ADDRESS,
        component: () =>
          import('./pages/BillingAddressStep/BillingAddressStep.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
        },
      },
      {
        path: 'payment',
        name: CHECKOUT_GIFT_CARDS.PAYMENT,
        component: () => import('./pages/PaymentStep/PaymentStep.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
          payment: {
            contentSecurityPoliciesEnabled: true,
          },
        },
      },
      {
        path: 'webview',
        redirect: { name: CHECKOUT_GIFT_CARDS.WEBVIEW.BILLING_ADDRESS },
        children: [
          {
            path: 'billing-address',
            name: CHECKOUT_GIFT_CARDS.WEBVIEW.BILLING_ADDRESS,
            component: () =>
              import('./pages/BillingAddressStep/BillingAddressStep.vue'),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
              auth: {
                required: true,
                redirection: { name: ROUTES.AUTH.LOGIN },
              },
            },
          },
          {
            path: 'payment',
            name: CHECKOUT_GIFT_CARDS.WEBVIEW.PAYMENT,
            component: () => import('./pages/PaymentStep/PaymentStep.vue'),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
              auth: {
                required: true,
                redirection: { name: ROUTES.AUTH.LOGIN },
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: 'checkout/gift-card/:requestId/payment-result',
    name: CHECKOUT_GIFT_CARDS.PAYMENT_RESULT,
    component: () =>
      import('../../pages/GiftCardsResults/GiftCardsResults.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
      },
    },
  },
]

export default routes
